import React from 'react'
import PropTypes from 'prop-types'
import Joyride, { ACTIONS, EVENTS, STATUS } from 'react-joyride'

/* Onbaording (via react-joyride) experience for TopicPlan page */
export default class AudiencePageOnBoarding extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    includeTlm: PropTypes.bool.isRequired,
    run: PropTypes.bool.isRequired,
    setScroll: PropTypes.func.isRequired,
    includeVennDiagram: PropTypes.bool
  }

  constructor (props) {
    super(props)

    this.state = {
      showModel: false,
      stepIndex: 0,
      run: false
    }
  }

  static defaultProps = {
    includeTlm: true
  }

  _steps () {
    const common = {
      placement: 'auto',
      placementBeacon: 'auto',
      disableBeacon: false,
      styles: {
        options: {
          zIndex: 10000
        }
      },
      locale: { skip: 'Skip tour' }
    }
    let steps = [
      {
        ...common,
        content: (<p>Welcome to the Diesel Labs dashboard for {this.props.name}<br /><br />This analysis illuminates the content consumption profile for the audience across networks, platforms, genres, and much more.</p>),
        placement: 'center',
        disableBeacon: true,
        target: 'body'
      },
      {
        ...common,
        content: (<p>Summary metrics break down the preferences of the selected audience vs average (e.g., a value of 20% for network content means that this audience watches and talks about content produced by TV networks 20% more than the average audience). Click on the labels to filter the table to the right, or click on the arrows above the charts to cycle through more of the list.</p>),
        target: '#tlmRow'
      },
      {
        ...common,
        content: (<p>Filter the table by content type, programming type, and/or genre to hone in on specific areas of interest.</p>),
        target: '#filter'
      },
      {
        ...common,
        content: (<p>Click on Brands & Ad Sales in the menu to navigate to a details page that illuminates the audiences engagement levels with brands and brand categories.<br/><br/>Similarly, click on Demographics to observe the gender and age breakdown for the audience, as well as their top lifestyles.</p>),
        target: '#brandDemo'
      },
      {
        ...common,
        content: (<p>Anticipation reveals which unreleased content the audience is excited about, including shows, movies, and even popular trailers.<br/><br/>Let's Go!</p>),
        target: '#trendingAnticipation'
      }
    ]

    return steps
  }

  handleJoyrideCallback = data => {
    const { action, index, status, type } = data

    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      this.setState({ stepIndex: index + (action === ACTIONS.PREV ? -1 : 1) })
      if (index == 2) {
        this.setState({showModel: false})
      }
    }
    else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      this.setState({ run: false })
    }
  }

  render () {
    // This fills up the logs quite a bit...so let's disable it by default.
    const debug = false

    return (
      <Joyride
        steps={this._steps()}
        run={this.props.run}
        debug={debug}
        continuous
        controlled
        showProgress
        showSkipButton
        callback= {this.handleJoyrideCallback}
        />
    )
  }
}
